<template>
	<section class="contact-us section" >
			<div class="container" style="padding: 100px;">    
				<div class="row">
					<div class="col-xs-12 col-sm-6">
						<div class="contact-content">
							<div class="comm-title">
								<h3>Contact Us</h3>
							</div>
							<p>Thank you for your interest in InCube’s innovative supply chain solutions, products and services. InCube Mobility Solution strives to provide the best service possible to all visitors as we operate in an industry built on trust. From basic questions to demo inquiries, we're here to help! Get in touch with us today!
							</p> 
						</div> <!-- /.contact-content -->
						<div class="lets-contact">
							 <ul class="contact-list">
								<li>
									<a href="#"><i class="fa fa-paper-plane-o"></i>1166 S Service Rd W, Oakville, ON L6L 5T7, Canada</a>
								</li>
								<li>
									<a href="#"><i class="fa fa-envelope-o"></i>marketing@e-incube.ca</a>
								</li>
								<li>
									<a href="#"><i class="fa fa-phone"></i>+1 (905) 465-9696</a>
								</li>
								<li>
									<a href="#"><i class="fa fa-history"></i>8.00 am to 5.00 pm , Monday to Friday </a>
								</li>

							</ul> <!-- /.contact-list -->
							<div class="contact-social">
								<ul>
								  <li>
									  <a href="https://www.facebook.com/InCubeMobility">
										  <i class="fa normal-show fa-facebook"></i>
										  <i class="fa hover-show fa-facebook"></i>
									  </a>
								  </li>
								

								  <li>
									  <a href="https://www.linkedin.com/company/incube-mobility-solutions">
										  <i class="fa normal-show fa-linkedin"></i>
										  <i class="fa hover-show fa-linkedin"></i>
									  </a>
								  </li>
							  </ul>
							</div> <!-- /.contact-social -->
						</div> <!-- /.lets-contact -->
					</div> <!-- /.col- -->
					<div class="col-xs-12 col-sm-6">
						<div class="border-in">
							<div class="comm-title">
								<h3>Get in touch with us</h3>
							</div>
							<div class="contact-form" >
								<form @submit.prevent="sendEmail">
									<div class="row">
										<div class="col-xs-12 col-sm-12">
											<div class="form-group">
												<input type="text"  name="user_name" class="form-control" placeholder="Your Name" required="required" data-error="Write your name">
											</div>
										</div> <!-- /.col- -->
										<div class="col-xs-12 col-sm-12">
											<div class="form-group">
												<input type="email" name="user_email" class="form-control" placeholder="Your Email" required="required" data-error="Write your valid email address">
											</div>
										</div> <!-- /.col- -->
										<div class="col-xs-12 col-sm-12">
											<div class="form-group">
												<input type="text" name="subject" class="form-control" placeholder="Your Subject">
											</div>
										</div> <!-- /.col- -->

										<div class="col-xs-12 col-sm-12">
											<div class="form-group">
												<textarea name="message" class="form-control" placeholder="Your Message" required="required" data-error="Write your comment"></textarea>
											</div>
										</div> <!-- /.col- -->
										<div class="form-group col-xs-12">
											<div class="form-btn">
												<input type="submit" name="submit" value="Send" class="contact-form-btn">
											</div>
										</div>
										<div class="messages"></div>
									</div> <!-- /.row -->
								</form>
							</div> <!-- /.contact-form -->
						</div>
					</div> <!-- /.col- -->
				</div> <!-- /.row -->  
			</div> <!-- /.container -->
		</section> <!-- /.contact-us -->
		<!-- /Contact AREA END -->
</template>

<script >
import emailjs from 'emailjs-com';

export default {
  methods: {
    sendEmail: (e) => {
      emailjs.sendForm('service_ayw9s2u', 'template_ccuxa69', e.target, 'user_ABLqnQsG8YSY5I1R3rNi6')
        .then((result) => {
            console.log('SUCCESS!', result.status, result.text);
        }, (error) => {
            console.log('FAILED...', error);
        });
    }
  }
}
</script>